import React, { useState, useEffect } from "react";
import styles from "./Customers.module.sass";
import TopSource from "./TopSource";
import Overview from "./Overview";
import StatProspect from "./StatProspect";
import EvolutionProspect from "./EvolutionProspect";
import ProductActivity from "./ProductActivity";
import { getProspectDashboardData } from "../../services/prospectDashboard.service";

const ProspectDashboard = () => {
  const [dashboardData, setDashboardData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        const data = await getProspectDashboardData();
        setDashboardData(data);
        setError(null);
      } catch (err) {
        console.error("Failed to fetch prospect dashboard data:", err);
        setError("Impossible de charger les données du dashboard.");
        setDashboardData(null);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  if (loading) {
    return (
      <div className={styles.loading}>
        <p>Chargement du dashboard prospects...</p>
      </div>
    );
  }

  if (error) {
    return (
      <div className={styles.error}>
        <p style={{ color: 'red' }}>{error}</p>
      </div>
    );
  }

  return (
    <>
      <div className={styles.shop}>
        <div className={styles.background}>
          <img src="/images/content/bg-shop.jpg" alt="Background" />
        </div>
        <div className={styles.row}>
          <div className={styles.col}>
            <Overview 
              className={styles.card} 
              overviewData={dashboardData?.overview}
            />
            <EvolutionProspect 
              className={styles.card} 
              evolutionData={dashboardData?.evolution}
            />
            <ProductActivity 
              className={styles.card} 
              commercialActivityData={dashboardData?.commercialActivity}
            />
          </div>
          <div className={styles.col}>
            <StatProspect className={styles.card} />
            <TopSource 
              className={styles.card} 
              sourcesData={dashboardData?.sources}
            />
           
          </div>
        </div>
      </div>
    </>
  );
};

export default ProspectDashboard;
